module.exports = __webpack_public_path__ + "img/logo-nxb.39489e92.jpg";